<template>
  <RCard class="title-list">
    <ConfirmationDialog
      ref="confirmDialog"
      cancel-label="cancel"
      confirm-label="Yes, delete"
      confirm-btn-type="danger"
    />

    <AgGrid :options="gridOptions" :row-data="titleLists" @cell-value-changed="cellValueChanged">
      <template #header>
        <Grid gaf="column" justify-content="space-between" class="q-mb-lg">
          <div class="text-subtitle-1 text-secondary-2 q-ml-sm q-mt-sm">ITEMS</div>

          <Grid gaf="column" align-items="center">
            <RBtn size="small" type="link" :to="{ name: 'product-title-list-manual-create', params: { id } }">
              add manually
            </RBtn>

            <RBtn size="small" type="link" :to="{ name: 'product-title-list-imports-create', params: { id } }">
              import
            </RBtn>
          </Grid>
        </Grid>
      </template>
    </AgGrid>
  </RCard>
</template>

<script>
import * as apiTo from '@/modular-api'
// Mixins
import gridOptions from './gridOptions'
// Libraries
import { mapState, mapActions } from 'vuex'
// Components
import AgGrid from '@/ag-grid/AgGrid'
import ConfirmationDialog from '@/ui/ConfirmationDialog'

export default {
  components: {
    ConfirmationDialog,
    AgGrid
  },

  mixins: [gridOptions],

  props: {
    id: [Number, String] // from route
  },

  computed: {
    ...mapState('product-show', ['titleLists'])
  },

  created() {
    this.getAndSetTitleLists()
  },

  methods: {
    ...mapActions('product-show', ['getAndSetTitleLists']),

    cellValueChanged({ column, newValue, data }) {
      let valueForBE = newValue
      if (['valid_from', 'valid_to'].includes(column.colId)) {
        valueForBE = this.formatDateForPost(valueForBE)
      }

      apiTo.MODIFY_TITLE_LIST(data.id, { [column.colId]: valueForBE || null }).finally(this.getAndSetTitleLists)
    },

    duplicate(row) {
      apiTo.COPY_TITLE_LIST(row.id).then(this.getAndSetTitleLists)
    },

    delete(row) {
      apiTo.GET_TITLE_LIST_DELETE_CONFIRMATION(row.id).then(({ data }) => {
        const dialog = this.$refs.confirmDialog.show({
          title: data.messages.default.join('\n'),
          noConfirm: !data.result.deletable,
          noCancel: !data.result.deletable,
          persistent: data.result.deletable
        })

        dialog.onCancel(hide => hide())
        dialog.onConfirm((hide, setLoading) => {
          setLoading()
          apiTo
            .DELETE_TITLE_LIST(row.id)
            .then(() => {
              this.getAndSetTitleLists()
              hide()
            })
            .catch(() => hide())
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins';

.title-list {
  @include table-with-no-filters;
}
</style>
